export const diseases_toxin_eng = [
  {
    label: 'Constipation',
    label_show: 'Constipation',
    page: 13,
    Xpos_image: '224px',
    Ypos_image: '480px',
    Xlabel: '230px',
    Ylabel: '570px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 1, max: 3, image: 'constipation_0' },
      { min: 4, max: 6, image: 'constipation_1' },
      { min: 7, max: 10, image: 'constipation_2' }
    ]
  },
  {
    label: 'Diarrhea',
    label_show: 'Diarrhea',
    page: 13,
    Xpos_image: '360px',
    Ypos_image: '480px',
    Xlabel: '377px',
    Ylabel: '570px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 1, max: 3, image: 'diarrhea_0' },
      { min: 4, max: 6, image: 'diarrhea_1' },
      { min: 7, max: 10, image: 'diarrhea_2' }
    ]
  },
  {
    label: 'Immune disorder',
    label_show: 'Immune Dysfunction',
    page: 13,
    Xpos_image: '495px',
    Ypos_image: '480px',
    Xlabel: '480px',
    Ylabel: '570px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 1, max: 3, image: 'immunedisorder_0' },
      { min: 4, max: 6, image: 'immunedisorder_1' },
      { min: 7, max: 10, image: 'immunedisorder_2' }
    ]
  },
]

export const diseases_toxin_thai = [
  {
    label: 'Constipation',
    label_show: 'ท้องผูก',
    page: 12,
    Xpos_image: '224px',
    Ypos_image: '480px',
    Xlabel: '243px',
    Ylabel: '570px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 1, max: 3, image: 'constipation_0' },
      { min: 4, max: 6, image: 'constipation_1' },
      { min: 7, max: 10, image: 'constipation_2' }
    ]
  },
  {
    label: 'Diarrhea',
    label_show: 'ท้องเสีย',
    page: 12,
    Xpos_image: '360px',
    Ypos_image: '480px',
    Xlabel: '380px',
    Ylabel: '570px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 1, max: 3, image: 'diarrhea_0' },
      { min: 4, max: 6, image: 'diarrhea_1' },
      { min: 7, max: 10, image: 'diarrhea_2' }
    ]
  },
  {
    label: 'Immune disorder',
    label_show: 'ภูมิคุ้มกันบกพร่อง',
    page: 12,
    Xpos_image: '495px',
    Ypos_image: '480px',
    Xlabel: '492px',
    Ylabel: '570px',
    width: '79px',
    height: 'auto',
    result_comp: [
      { min: 1, max: 3, image: 'immunedisorder_0' },
      { min: 4, max: 6, image: 'immunedisorder_1' },
      { min: 7, max: 10, image: 'immunedisorder_2' }
    ]
  },  
]

export const diseases_image_toxin_eng = [
  // {
  //   label: 'Eczema',
  //   label_show: 'Eczema',
  //   page: 12,
  //   Xpos_image: '77px',
  //   Ypos_image: '685px',
  //   Xlabel: '90px',
  //   Ylabel: '757px',
  //   width: '70px',
  //   height: 'auto'
  // },
];

export const diseases_image_toxin_thai = [
  // {
  //   label: 'Eczema',
  //   label_show: 'Eczema',
  //   page: 12,
  //   Xpos_image: '77px',
  //   Ypos_image: '685px',
  //   Xlabel: '90px',
  //   Ylabel: '757px',
  //   width: '70px',
  //   height: 'auto'
  // },
];